// extracted by mini-css-extract-plugin
export default {"select":"RepatchDropdown_select__p5LHH"};